import { render } from "./LeftAside.vue?vue&type=template&id=22008598&scoped=true&ts=true"
import script from "./LeftAside.vue?vue&type=script&lang=ts"
export * from "./LeftAside.vue?vue&type=script&lang=ts"

import "./LeftAside.vue?vue&type=style&index=0&id=22008598&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22008598"]])

export default __exports__